import {Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {DivisionsService} from "../../core/services/divisions.service";

@Component({
  selector: 'app-flag-container-v2',
  templateUrl: './flag-container-v2.component.html',
  styleUrls: ['./flag-container-v2.component.scss']
})
export class FlagContainerV2Component implements OnInit, OnChanges{
  private _divisionName: string;
  @Input() id: string;
  @Input() divisionName;
  @Input() classes: string;
  @Input() fixed: boolean;
  @Input() discount: number;
  @Input() game: string;
  @Input() service: string;
  @Input() state?: string;
  public isBrowser = false;
  public baseUrl = '';
  public divisionService = DivisionsService;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.divisionName || changes.game) {
      this.processDivisionName();
    }
  }

  private processDivisionName(): void {
    this._divisionName = this.divisionName;
    if (this.game === 'cs2' && (this.service === 'divisions' || (this.service === 'netwins' && this.id === 'current'))) {
      let divisionInt = parseInt(this.divisionName, 10);
      this._divisionName = (Math.floor(divisionInt / 5000) * 5000).toString();
    } else if (this.game === 'cs2' && this.service === 'masteries') {
      this._divisionName = this.getCompetitiveFlagColors();
    } else if (this.game === 'cs2' && this.service === 'placements') {
      this._divisionName = 'blue';
    } else if (this.game === 'cs2' && this.service === 'netwins' && this.id === 'desired' && !this.state) {
      this._divisionName = 'blue';
    }
  }

  getCompetitiveFlagColors(){
    if(this.divisionService.getMasteryValue(this.divisionName,this.game) <= 6){
      return 'grey';
    } else if(this.divisionService.getMasteryValue(this.divisionName,this.game) <= 13){
      return 'blue';
    } else if(this.divisionService.getMasteryValue(this.divisionName,this.game) <= 18){
      return 'gold';
    }
    return '';
  }

  get processedDivisionName(): string {
    return this._divisionName;
  }

  constructor(@Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.baseUrl = window.location.href.replace(window.location.hash, '');
    }
  }

  ngOnInit(): void {
  }
}
